// extracted by mini-css-extract-plugin
export default {"container":"page-area-supplier-assign_container__S0muw"};